/**
 * triggerResize
 */

/* eslint-disable */
const triggerResize = {
    init() {
        window.addEventListener('load', () => {
            window.dispatchEvent(new Event('resize'));
        });
    }
};
/* eslint-enable */
export default triggerResize;



// WEBPACK FOOTER //
// ./___src/assets/js/scripts/triggerResize.js